import { render, staticRenderFns } from "./scientific-analysis-noresults-panel.vue?vue&type=template&id=f5c29080&scoped=true&"
import script from "./scientific-analysis-noresults-panel.ts?vue&type=script&lang=ts&"
export * from "./scientific-analysis-noresults-panel.ts?vue&type=script&lang=ts&"
import style0 from "./scientific-analysis-noresults-panel.scss?vue&type=style&index=0&id=f5c29080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c29080",
  null
  
)

export default component.exports